import React from "react"

import { IconButton, MuiIcon } from "@cirrus/ui-kit-ts"

import { useNavigationService } from "../providers/NavigationService"

export const GoBack = (props) => {
  const { navigate } = useNavigationService()

  return <IconButton
    {...props}
    muiIcon={<MuiIcon.ArrowBack fontSize="small" />}
    sx={{ position: "absolute", left: 0 }}
    title={"Go back"}
    onClick={() => navigate(-1)} />
}
